import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

export function useLastPromptPreferencesPersistence(): useLastPromptPreferencesPersistenceReturn {
  return useLazyContext(LastPromptPreferencesPersistenceContext);
}

export const LastPromptPreferencesPersistenceContext =
  createContext<LazyValue<useLastPromptPreferencesPersistenceReturn>>(
    undefined,
  );

export type useLastPromptPreferencesPersistenceReturn = {
  getLastPrompted: () => Promise<Date | undefined>;
  setLastPrompted: (date: Date) => Promise<void>;
};
